(() => {
  const galleryScript = document.currentScript || Array.from(document.scripts).find((script) =>
    script.src.includes('thin-candles-pdp.js')
  );
  const galleryArrowUrl = galleryScript?.src
    ? new URL('arrow-down-white.svg', galleryScript.src).href
    : '';

  const updateSelectedScents = () => {
    document.querySelectorAll('[data-candle-color-scent]').forEach((scentLabel) => {
      const colorOption = scentLabel.closest('.candle-color-picker');
      const selectedColor = colorOption?.querySelector('input:checked');
      const scent = selectedColor?.closest('[data-candle-scent]')?.dataset.candleScent;

      if (scent) scentLabel.textContent = scent;
    });
  };

  const formatProductMoney = (cents) => {
    if (typeof window.formatMoney === 'function' && window.MinimogSettings?.money_format) {
      return window.formatMoney(cents, window.MinimogSettings.money_format);
    }

    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(cents / 100);
  };

  const updateAddToCartPrice = (root, variantOverride) => {
    if (root.querySelector('candle-subscription-options, [data-stillness-configurator]')) return;

    const variantsJson = root.querySelector('variant-picker #productVariants');
    const variantInput = root.querySelector('.m-product-form--main form input[name="id"]');
    const button = root.querySelector('.m-product-form--main .m-add-to-cart');
    const buttonText = button?.querySelector('.m-add-to-cart--text');
    if (!button || !buttonText || button.classList.contains('disabled')) return;

    let selectedVariant = variantOverride;
    if (!selectedVariant) {
      if (!variantsJson || !variantInput) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsJson.textContent);
      } catch (_error) {
        return;
      }

      selectedVariant = variants.find((variant) => String(variant.id) === String(variantInput.value));
    }

    if (!selectedVariant) return;

    const currentPrice = formatProductMoney(selectedVariant.price);
    const comparePrice = selectedVariant.compare_at_price > selectedVariant.price
      ? formatProductMoney(selectedVariant.compare_at_price)
      : '';
    const signature = `${comparePrice}|${currentPrice}`;
    const renderedCurrentPrice = buttonText.querySelector('[data-atc-current-price]')?.textContent;
    const renderedComparePrice = buttonText.querySelector('[data-atc-compare-price]')?.textContent || '';
    if (
      buttonText.dataset.candlePriceSignature === signature &&
      renderedCurrentPrice === currentPrice &&
      renderedComparePrice === comparePrice
    ) return;

    buttonText.dataset.candlePriceSignature = signature;
    buttonText.replaceChildren(document.createTextNode(`${button.dataset.atcText || 'Add to cart'} – `));

    if (comparePrice) {
      const comparePriceElement = document.createElement('s');
      comparePriceElement.className = 'm-atc-price__compare';
      comparePriceElement.dataset.atcComparePrice = '';
      comparePriceElement.textContent = comparePrice;
      buttonText.append(comparePriceElement);
    }

    const currentPriceElement = document.createElement('span');
    currentPriceElement.className = 'm-atc-price__current';
    currentPriceElement.dataset.atcCurrentPrice = '';
    currentPriceElement.textContent = currentPrice;
    buttonText.append(currentPriceElement);
  };

  const updateRolloutProductDetails = () => {
    updateSelectedScents();
    document.querySelectorAll('.m-main-product[data-candle-pdp-rollout="true"]').forEach(updateAddToCartPrice);
  };

  const watchAddToCartPrices = () => {
    document.querySelectorAll('.m-main-product[data-candle-pdp-rollout="true"]').forEach((root) => {
      const buttonText = root.querySelector('.m-product-form--main .m-add-to-cart--text');
      if (!buttonText || buttonText.dataset.candlePriceWatched === 'true') return;

      buttonText.dataset.candlePriceWatched = 'true';
      new MutationObserver(() => {
        window.requestAnimationFrame(() => updateAddToCartPrice(root));
      }).observe(buttonText, { childList: true, characterData: true, subtree: true });
    });
  };

  document.addEventListener('variant:changed', (event) => {
    updateSelectedScents();
    document.querySelectorAll('.m-main-product[data-candle-pdp-rollout="true"]').forEach((root) => {
      updateAddToCartPrice(root, event.detail?.variant);
    });
  });
  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-picker')) window.setTimeout(updateRolloutProductDetails, 50);
  });
  watchAddToCartPrices();

  const createButton = (direction) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `candle-gallery-nav candle-gallery-nav--${direction}`;
    button.setAttribute('aria-label', direction === 'previous' ? 'Previous product images' : 'Next product images');
    const icon = document.createElement('img');
    icon.src = galleryArrowUrl;
    icon.alt = '';
    icon.width = 12;
    icon.height = 14;
    button.append(icon);
    return button;
  };

  const enhanceGallery = (gallery, isMobileGallery) => {
    if (gallery.dataset.candleGalleryEnhanced === 'true') return;

    const slider = gallery.querySelector('.m-product-media--slider');
    const thumbnails = gallery.querySelector('.m-product-media--slider__thumbnails');
    const navContainer = gallery.querySelector('.nav-swiper-container');
    const slides = navContainer?.querySelectorAll('.swiper-slide');

    const minimumSlides = isMobileGallery ? 3 : 4;
    if (!slider || !thumbnails || !navContainer || !slides || slides.length <= minimumSlides || !gallery.navSlider) return;

    gallery.dataset.candleGalleryEnhanced = 'true';
    const previous = createButton('previous');
    const next = createButton('next');
    thumbnails.prepend(previous);
    thumbnails.append(next);

    const syncImageTrackHeight = (height) => {
      const imageSlider = slider.querySelector('.m-product-media--slider__images');
      if (!imageSlider) return;

      const imageElements = imageSlider.querySelectorAll(
        '.swiper-wrapper, .swiper-slide, .m-product-media, responsive-image, img'
      );

      imageElements.forEach((element) => {
        if (height) {
          element.style.setProperty('height', `${height}px`, 'important');
        } else {
          element.style.removeProperty('height');
        }
      });
    };

    const updateButtons = () => {
      previous.disabled = gallery.navSlider.isBeginning;
      next.disabled = gallery.navSlider.isEnd;
    };

    const scrollThumbnailRail = (direction) => {
      if (!isMobileGallery) {
        gallery.navSlider[direction === 'previous' ? 'slidePrev' : 'slideNext']();
        return;
      }

      const visibleSlides = 3;
      const lastIndex = Math.max(0, gallery.navSlider.slides.length - visibleSlides);
      const currentIndex = gallery.navSlider.activeIndex || 0;
      const targetIndex = direction === 'previous'
        ? Math.max(0, currentIndex - visibleSlides)
        : Math.min(lastIndex, currentIndex + visibleSlides);

      gallery.navSlider.slideTo(targetIndex);
    };

    previous.addEventListener('click', () => scrollThumbnailRail('previous'));
    next.addEventListener('click', () => scrollThumbnailRail('next'));
    gallery.navSlider.on('slideChange', updateButtons);
    gallery.navSlider.on('reachBeginning', updateButtons);
    gallery.navSlider.on('reachEnd', updateButtons);

    if (isMobileGallery) {
      const syncMobileGallery = () => {
        if (!window.matchMedia('(max-width: 767px)').matches) return;

        const imageSlider = slider.querySelector('.m-product-media--slider__images');
        const galleryHeight = imageSlider?.clientWidth;
        if (!imageSlider || !galleryHeight) return;

        gallery.navSlider.params.slidesPerView = 'auto';
        gallery.navSlider.params.spaceBetween = 8;
        if (gallery.navSlider.params.direction !== 'vertical') {
          if (typeof gallery.navSlider.changeDirection === 'function') {
            gallery.navSlider.changeDirection('vertical', false);
          } else {
            gallery.navSlider.params.direction = 'vertical';
          }
        }

        slider.style.height = `${galleryHeight}px`;
        thumbnails.style.height = `${galleryHeight}px`;
        syncImageTrackHeight(galleryHeight);
        gallery.slider?.update();
        gallery.navSlider.update();
        updateButtons();
      };

      const resizeObserver = new ResizeObserver(syncMobileGallery);
      resizeObserver.observe(slider);
      window.addEventListener('resize', syncMobileGallery);
      syncMobileGallery();
      updateButtons();
      return;
    }

    const syncGalleryHeight = () => {
      let galleryHeight = null;

      if (window.matchMedia('(min-width: 1024px)').matches) {
        galleryHeight = slider.clientWidth - 112;
        slider.style.height = `${galleryHeight}px`;
      } else {
        slider.style.removeProperty('height');
        syncImageTrackHeight(null);
      }

      gallery.slider?.update();
      gallery.navSlider.update();
      syncImageTrackHeight(galleryHeight);
    };
    const resizeObserver = new ResizeObserver(syncGalleryHeight);
    resizeObserver.observe(slider);

    const reviewSection = gallery.closest('.candle-media-sticky-group')?.querySelector(
      '.candle-reviews-section--docked'
    );
    if (reviewSection) resizeObserver.observe(reviewSection);

    window.addEventListener('resize', syncGalleryHeight);
    syncGalleryHeight();
    updateButtons();
  };

  const initialize = () => {
    const galleries = document.querySelectorAll(
      '.m-product-media--layout-6 media-gallery, ' +
      '.m-main-product[data-candle-pdp-rollout="true"] .m-product-media--mobile.m-product-media--layout-6 media-gallery-mobile'
    );
    let attempts = 0;

    const waitForSliders = () => {
      let pending = false;

      galleries.forEach((gallery) => {
        if (!gallery.navSlider) pending = true;
        enhanceGallery(gallery, gallery.matches('media-gallery-mobile'));
      });

      attempts += 1;
      if (pending && attempts < 200) window.setTimeout(waitForSliders, 50);
    };

    waitForSliders();
  };

  Promise.all([
    customElements.whenDefined('media-gallery'),
    customElements.whenDefined('media-gallery-mobile')
  ]).then(initialize);
  updateRolloutProductDetails();
  [100, 500, 1200].forEach((delay) => window.setTimeout(updateRolloutProductDetails, delay));
})();
